exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".acccordion{\n  width: 100%;\n  overflow: hidden;\n  background-color: #272727;\n  border: 1px solid #272727;\n  height: auto;\n  border-radius: 10px;\n  margin-bottom: 40px;\n}", ""]);

